<template>
  <div>
    <tk-flex  between >
      <public-header :title="pageData.name || ''" show-back></public-header>
      <a-button type="primary" @click="edit" v-if="giftType === '0'" >
        申请买赠
      </a-button>
      <a-button type="primary" @click="cancel" v-if="giftType === '2'" >
        取消买赠
      </a-button>
    </tk-flex>
    <a-spin :spinning="loading" class="full-width" style="min-height: 60vh;" >
      <div style="display: none;">.</div>
      <div class="full-width bg-white border-radius-12" v-if="pageData && pageData.objectId" >
        <Layout :showMenu="true" :menuList="menuList" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="true" :mainImageUrl="pageData.images[0]"  >
          <template slot="content" >
            <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
            <div v-show="key === 0" style="height:100%">
              <a-row :gutter="[20,20]" class="font-12" style="color: #363B45" >
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  系列：{{ pageData.series.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  电压v：{{ pageData.voltage.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  容量AH：{{ pageData.capacity.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  以旧换新价：{{ pageData.tradePrice }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  直接购买价：{{ pageData.price }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  商品积分：{{ pageData.points }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  商品描述：{{ pageData.introduce }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  <tk-flex>
                    <div class="unshrink">商品详情：</div>
                    <div v-html="pageData.details" class="p-15" style="height: 450px; width: 100%;overflow-y: scroll;border-radius: 6px;border: 1px solid #DBDDE1;" ></div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  <tk-flex>
                    <div class="unshrink">商品图片：</div>
                    <tk-flex wrap>
                      <!-- <div v-for="(item, index) in pageData.images" :key="index" class="m-r-10 m-b-10" > -->
                        <viewer v-if="pageData.images.length" :images="pageData.images">
                          <img v-for="(item, index) in pageData.images" :key="index" :src="item" style="width: 120px;height:120px;object-fit:cover;margin-right: 5px;border-radius: 6px;border: 1px solid #DBDDE1;" />
                        </viewer>
                        <!-- <tk-image :width="120" :height="120" :src="item" style="" /> -->
                      <!-- </div> -->

                    </tk-flex>
                  </tk-flex>
                </a-col>
              </a-row>
            </div>
            <div v-show="key === 1" style="height:100%">
              <div class="font-12 m-b-20" style="color: #363B45">
                买赠类型：{{ giftType === '1' ? '全国买赠' : giftType === '2' ? '区域买赠' : '暂未开启' }}
              </div>
              <div v-if="giftType !== '0'" >
                <tk-flex class="m-b-24">
                  <div class="font-12 unshrink" style="color: #363B45" >买赠主图：</div>
                  <div class="fill">
                    <viewer :images="[mainImage]">
                      <img :src="mainImage" style="width: 120px;height:120px;object-fit:cover;margin-right: 5px;border-radius: 6px;border: 1px solid #DBDDE1;" />
                    </viewer>
                  </div>
                </tk-flex>
                <tk-flex style="width: 100%">
                  <div class="font-12 unshrink" style="color: #363B45" >包含赠品：</div>
                </tk-flex>
                <div class="m-t-10 m-b-24">
                  <a-table
                    v-if="device !== 'mobile'"
                    style="width: 100%"
                    :columns="columns"
                    :data-source="data"
                    bordered
                    :pagination="false"
                    :scroll="{x: 600}"
                    size="small"
                  >
                    <div slot="image" slot-scope="text">
                      <viewer v-if="text" :images="[text]">
                        <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                      </viewer>
                      <span v-else> 暂无 </span>
                    </div>
                    <div slot="gift" slot-scope="text, record">{{ record.giftData.name }}</div>
                  </a-table>
                  <div v-else>
                    <a-descriptions bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
                      <a-descriptions-item
                        v-for="( itm, i) in columns" :key="`item${i}`"
                        :label="itm.title"
                      >
                        <div v-if="itm.dataIndex === 'image'">
                          <viewer v-if="item[itm.dataIndex]" :images="[item[itm.dataIndex]]">
                            <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                          </viewer>
                          <span v-else> 暂无 </span>
                        </div>
                        <div v-else-if="itm.dataIndex === 'gift'">
                          {{ item.giftData.name }}
                        </div>
                        <div v-else>{{ item[itm.dataIndex] }}</div>
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                </div>

                <tk-flex class="m-b-24">
                  <div class="font-12 unshrink" style="color: #363B45" >截止日期：</div>
                  <div class="fill">
                    {{ deadline | day }}
                  </div>
                </tk-flex>

                <tk-flex>
                  <div class="font-12 unshrink" style="color: #363B45" >是否邮寄：</div>
                  <div class="fill">{{ pinkage ? '是' : '否' }}</div>
                </tk-flex>
              </div>
            </div>
          </template>
        </Layout>
        <Basic :visible.sync="showBasic" :record="pageData" @refresh="refresh" ></Basic>
        <Accredit v-if="showAccredit" :record="pageData" :vm="this" ></Accredit>
        <Gift v-if="showGift" :record="pageData" :winWinMerchantProduct="agentData" :vm="this" ></Gift>
      </div>
    </a-spin>
  </div>
</template>
<script>
import Layout from '../components/layout.vue'
import publicHeader from '../../components/publicHeader.vue'
import Basic from './component/basic.vue'
import Accredit from './component/accredit.vue'
import Gift from './component/giftAgent.vue'
export default {
  components: {
    publicHeader,
    Layout,
    Basic,
    Accredit,
    Gift
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      agentData: null,
      menuList: [
        {
          name: '基本信息'
        },
        {
          name: '买赠设置'
        }
      ],
      key: 0,
      showBasic: false,
      warZone: '',
      region: '',
      showAccredit: false,
      showGift: false,
      columns: [
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '名称',
          dataIndex: 'gift',
          key: 'gift',
          scopedSlots: { customRender: 'gift' },
          width: 300
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '成本价',
          key: 'costPrice',
          dataIndex: 'costPrice',
          scopedSlots: { customRender: 'costPrice' },
          width: 100
        },
        {
          title: '售价',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          width: 100
        }
      ],
      data: [
        {
          image: '',
          gift: '',
          number: '1件',
          costPrice: '',
          price: ''
        }
      ],
      regionObj: {
        objectId: '',
        agent: '',
        agentData: {},
        mainImage: '',
        image: '',
        gift: '',
        giftData: {},
        number: '1件',
        price: '',
        pinkage: '',
        deadline: ''
      },
      giftType: '0',
      mainImage: '',
      deadline: '',
      pinkage: ''
    }
  },
  watch: {
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        await this.getData()
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    // 获取数据
    async getData () {
      const { data } = await this.$tkParse.get(`/classes/winWinMerchantProduct/${this.$route.query.id}`, {
        params: { include: 'winWinMerchant,commodity.series,commodity.voltage,commodity.capacity,commodity.gift,gift' }
      })
      data.commodity.details = data.commodity.details.replace(/<img/g, '<img style="max-width:100%;height:auto"')
      this.giftType = data.commodity.giftType === '1' ? '1' : data.gift ? '2' : '0'
      console.log(this.giftType)
      if (this.giftType === '1') {
        this.data[0] = {
          image: data.commodity.gift.image,
          gift: data.commodity.gift.objectId,
          giftData: data.commodity.gift,
          number: '1件',
          costPrice: data.commodity.gift.costPrice,
          price: data.commodity.gift.price
        }
        this.mainImage = data.commodity.mainImage
        this.deadline = data.commodity.deadline
        this.pinkage = data.commodity.pinkage
      }
      if (this.giftType === '2') {
        this.data[0] = {
          image: data.gift.image,
          gift: data.gift.objectId,
          giftData: data.gift,
          number: '1件',
          costPrice: data.gift.costPrice,
          price: data.gift.price
        }
        this.mainImage = data.mainImage
        this.deadline = data.deadline
        this.pinkage = data.pinkage
      }
      this.pageData = data.commodity
      this.agentData = data
    },
    // 刷新商品
    refresh () {
      this.getData()
    },
    // 刷新买赠
    refreshGift () {
      this.getData()
    },
    // 取消买赠
    async cancel () {
      await this.confirm('警告', '确定取消吗？')
      await this.$tkParse.put(`/classes/winWinMerchantProduct/${this.agentData.objectId}`, {
        gift: null,
        mainImage: null,
        pinkage: null,
        deadline: null
      })
      await this.$tkParse.post(`/commodity/WWMProductActivity`, {
        commodity: this.pageData.objectId
      })
      this.$notification['success']({
        message: '取消成功',
        description: '取消成功'
      })
      this.loading = false
      this.init()
    },
    async edit () {
      let res = await this.$tkParse.get(`/classes/giftApply`, {
        params: {
          where: {
            winWinMerchantProduct: this.agentData.objectId,
            commodity: this.pageData.objectId,
            status: '0'
          }
        }
      })
      if (res.data.results.length) {
        this.$notification['warning']({
          message: '警告',
          description: '该商品已存在审核中的申请，请勿重复提交'
        })
        return
      }
      this.showGift = true
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
